export default "__VITE_ASSET__53f20d48__"